<template>
  <v-container>
    <ApplyCustomizing
      :showcase="showcase"
      v-if="displayMap.applyCustomizing"
      @close="closeForm"
    ></ApplyCustomizing>
    <ApplyCustomApplicationConfig
      :showcase="showcase"
      v-if="displayMap.applyCustomApplicationConfig"
      @close="closeForm"
    ></ApplyCustomApplicationConfig>
    <AddRecorderConfig
      :showcase="showcase"
      v-if="displayMap.addRecorderConfig"
      @close="closeForm"
    ></AddRecorderConfig>
    <UpdateLicense
      :showcase="showcase"
      v-if="displayMap.updateLicense"
      @close="closeForm"
    ></UpdateLicense>
    <UpdateVersion
      :showcase="showcase"
      v-if="displayMap.updateVersion"
      @close="closeForm"
    ></UpdateVersion>
    <CreateEnvironments
      :showcase="showcase"
      v-if="displayMap.createEnvironments"
      @close="closeForm"
    ></CreateEnvironments>
    <DeleteEnvironments
      :showcase="showcase"
      v-if="displayMap.deleteEnvironments"
      @close="closeForm"
    ></DeleteEnvironments>
    <CreateImage
      :showcase="showcase"
      v-if="displayMap.createImage"
      @close="closeForm"
    ></CreateImage>
    <SetToImage
      :showcase="showcase"
      v-if="displayMap.setToImage"
      @close="closeForm"
    ></SetToImage>
    <SetToLatestImage
      :showcase="showcase"
      v-if="displayMap.setToLatestImage"
      @close="closeForm"
    ></SetToLatestImage>
    <UpdateProperties
      :showcase="showcase"
      v-if="displayMap.updateProperties"
      @close="closeForm"
    ></UpdateProperties>
    <UpdateUrl
      :showcase="showcase"
      v-if="displayMap.updateUrl"
      @close="closeForm"
    ></UpdateUrl>
    <UpdateMultiEnv
      :showcase="showcase"
      v-if="displayMap.updateMultiEnv"
      @close="closeForm"
    ></UpdateMultiEnv>
    <v-card>
      <v-toolbar flat color="grey lighten-2">Run Operation</v-toolbar>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="3">
            <v-card>
              <v-card-title>Update running system</v-card-title>
              <v-card-text justify-center>
                <v-btn
                  class="operation-btn"
                  @click="showOperationForm('applyCustomizing')"
                  >Apply Customizing</v-btn
                >
                <v-btn
                  class="operation-btn"
                  @click="showOperationForm('applyCustomApplicationConfig')"
                  >Apply custom <br />application config</v-btn
                >
                <v-btn
                  class="operation-btn"
                  @click="showOperationForm('addRecorderConfig')"
                  >Add Recorder Config</v-btn
                >
                <v-btn
                  class="operation-btn"
                  @click="showOperationForm('updateLicense')"
                  >Update License</v-btn
                >
                <v-btn
                  class="operation-btn"
                  @click="showOperationForm('updateVersion')"
                  >Update Version</v-btn
                >
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" md="3">
            <v-card>
              <v-card-title>Manage Environments</v-card-title>
              <v-card-text justify-center>
                <v-btn
                  class="operation-btn"
                  @click="showOperationForm('createEnvironments')"
                  >Create Environments</v-btn
                >
                <v-btn
                  class="operation-btn"
                  @click="showOperationForm('deleteEnvironments')"
                  >Delete Environments</v-btn
                >
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" md="3">
            <v-card>
              <v-card-title>Image Operations</v-card-title>
              <v-card-text justify-center>
                <v-btn
                  class="operation-btn"
                  @click="showOperationForm('createImage')"
                  >Create Image</v-btn
                >
                <v-btn
                  class="operation-btn"
                  @click="showOperationForm('setToLatestImage')"
                  >Set to latest Image</v-btn
                >
                <v-btn
                  class="operation-btn"
                  @click="showOperationForm('setToImage')"
                  >Set to Image</v-btn
                >
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" md="3">
            <v-card>
              <v-card-title>Update Properties</v-card-title>
              <v-card-text justify-center>
                <v-btn
                  class="operation-btn"
                  @click="showOperationForm('updateProperties')"
                  >Update Properties</v-btn
                >
                <v-btn
                  class="operation-btn"
                  @click="showOperationForm('updateUrl')"
                  >Update Url</v-btn
                >
                <v-btn
                  class="operation-btn"
                  @click="showOperationForm('updateMultiEnv')"
                  >Update MultiEnv</v-btn
                >
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import ApplyCustomizing from './forms/ApplyCustomizing'
import AddRecorderConfig from './forms/AddRecorderConfig'
import ApplyCustomApplicationConfig from './forms/ApplyCustomApplicationConfig'
import UpdateLicense from './forms/UpdateLicense'
import UpdateVersion from './forms/UpdateVersion'
import CreateEnvironments from './forms/CreateEnvironments'
import DeleteEnvironments from './forms/DeleteEnvironments'
import CreateImage from './forms/CreateImage'
import SetToImage from './forms/SetToImage'
import SetToLatestImage from './forms/SetToLatestImage'
import UpdateProperties from './forms/UpdateProperties'
import UpdateUrl from './forms/UpdateUrl'
import UpdateMultiEnv from './forms/UpdateMultiEnv'
export default {
  name: 'ShowcaseOperationsExecution',
  components: {
    ApplyCustomizing,
    ApplyCustomApplicationConfig,
    UpdateLicense,
    UpdateVersion,
    AddRecorderConfig,
    CreateEnvironments,
    DeleteEnvironments,
    CreateImage,
    SetToImage,
    SetToLatestImage,
    UpdateProperties,
    UpdateUrl,
    UpdateMultiEnv
  },
  data: () => ({
    displayMap: {
      applyCustomizing: false,
      applyCustomApplicationConfig: false,
      addRecorderConfig: false,
      updateLicense: false,
      updateVersion: false,
      createEnvironments: false,
      deleteEnvironments: false,
      createImage: false,
      setToImage: false,
      setToLatestImage: false,
      updateProperties: false,
      updateUrl: false,
      updateMultiEnv: false
    }
  }),
  props: ['showcase'],
  methods: {
    showOperationForm: function(operation) {
      this.displayMap = this.updateDisplayMap(operation)
    },
    closeForm: function() {
      this.displayMap = this.updateDisplayMap('')
    },
    updateDisplayMap: operation => {
      return {
        applyCustomizing: operation === 'applyCustomizing',
        applyCustomApplicationConfig:
          operation === 'applyCustomApplicationConfig',
        updateLicense: operation === 'updateLicense',
        updateVersion: operation === 'updateVersion',
        addRecorderConfig: operation === 'addRecorderConfig',
        createEnvironments: operation === 'createEnvironments',
        deleteEnvironments: operation === 'deleteEnvironments',
        createImage: operation === 'createImage',
        setToImage: operation === 'setToImage',
        setToLatestImage: operation === 'setToLatestImage',
        updateProperties: operation === 'updateProperties',
        updateUrl: operation === 'updateUrl',
        updateMultiEnv: operation === 'updateMultiEnv'
      }
    }
  }
}
</script>

<style scoped>
.operation-btn {
  margin-bottom: 15px;
}
</style>
